<script setup lang="ts">
import LoaderWLogo from '@/components/Loaders/LoaderWLogo.vue'
import ReactComponent from '@/components/React/ReactComponent.vue'
</script>
<template>
  <Suspense>
    <template #default>
      <ReactComponent name="Root" />
    </template>
    <template #fallback>
      <div style="height: 100%; display: flex; align-items: center; justify-content: center">
        <LoaderWLogo />
      </div>
    </template>
  </Suspense>
</template>
